function ownKeys(e, r) { var t = Object.keys(e); if (Object.getOwnPropertySymbols) { var o = Object.getOwnPropertySymbols(e); r && (o = o.filter(function (r) { return Object.getOwnPropertyDescriptor(e, r).enumerable; })), t.push.apply(t, o); } return t; }
function _objectSpread(e) { for (var r = 1; r < arguments.length; r++) { var t = null != arguments[r] ? arguments[r] : {}; r % 2 ? ownKeys(Object(t), !0).forEach(function (r) { _defineProperty(e, r, t[r]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : ownKeys(Object(t)).forEach(function (r) { Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r)); }); } return e; }
function _defineProperty(e, r, t) { return (r = _toPropertyKey(r)) in e ? Object.defineProperty(e, r, { value: t, enumerable: !0, configurable: !0, writable: !0 }) : e[r] = t, e; }
function _toPropertyKey(t) { var i = _toPrimitive(t, "string"); return "symbol" == typeof i ? i : i + ""; }
function _toPrimitive(t, r) { if ("object" != typeof t || !t) return t; var e = t[Symbol.toPrimitive]; if (void 0 !== e) { var i = e.call(t, r || "default"); if ("object" != typeof i) return i; throw new TypeError("@@toPrimitive must return a primitive value."); } return ("string" === r ? String : Number)(t); }
import EventEmitter from './events';
import { optionsFromDataset, querySelectorAll, querySelector } from './dom';
import uuid from './uuid';
export default class Component extends EventEmitter {
  constructor(element) {
    let options = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};
    let defaultOptions = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : {};
    super();
    this.element = querySelector(element, document);

    // An invalid selector or non-DOM node has been provided.
    if (!this.element) {
      throw new Error(`An invalid selector or non-DOM node has been provided for ${this.constructor.name}.`);
    }
    this.element[this.constructor.name] = this.constructor._interface.bind(this);
    this.element[this.constructor.name].Constructor = this.constructor.name;
    this.id = uuid(this.constructor.name + '-');
    this.options = _objectSpread(_objectSpread(_objectSpread({}, defaultOptions), options), optionsFromDataset(this.element, defaultOptions));
  }

  /**
   * Initiate all DOM element corresponding to selector
   * @method
   * @return {Array} Array of all Plugin instances
   */
  static attach() {
    let selector = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : null;
    let options = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};
    let node = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : null;
    let instances = new Array();
    if (selector !== null) {
      querySelectorAll(selector, node).forEach(element => {
        // Check if plugin has already been instantiated for element
        if (typeof element[this.name] === 'undefined') {
          // If no then instantiate it and register it in element
          instances.push(new this(element, _objectSpread({
            selector: selector
          }, options)));
        } else {
          // If Yes then return the existing instance
          instances.push(element[this.name]);
        }
      });
      if (typeof window[this.name] === 'undefined') {
        window[this.name] = {
          'observers': []
        };
      }
      if (window[this.name]['observers'] && !window[this.name]['observers'].includes(selector)) {
        this.observeDom(selector, options);
        window[this.name]['observers'].push(selector);
      }
    }
    return instances;
  }

  /**
   * Observe DOM mutations to automatically initialize plugin on new elements when added to the DOM
   * 
   * @param {string} selector 
   * @param {Object} options 
   */
  static observeDom(selector, options) {
    const observer = new MutationObserver(mutations => {
      mutations.forEach(mutation => {
        for (let i = 0; i < mutation.addedNodes.length; i++) {
          if (typeof window[this.name] !== 'undefined') {
            this.attach(selector, options, mutation.addedNodes[i]);
          }
        }
      });
    });
    if (typeof document !== 'undefined') {
      observer.observe(document, {
        childList: true,
        subtree: true
      });
    }
  }
  static _interface() {
    let name = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : null;
    let options = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};
    if (typeof name === 'string') {
      if (typeof this[name] === 'undefined') {
        throw new TypeError(`No method named "${name}"`);
      }
      return this[name](options);
    }
    return this;
  }
}